import { render, staticRenderFns } from "./_params.vue?vue&type=template&id=3b52296f&scoped=true&lang=pug&"
import script from "./_params.vue?vue&type=script&lang=js&"
export * from "./_params.vue?vue&type=script&lang=js&"
import style0 from "./_params.vue?vue&type=style&index=0&id=3b52296f&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b52296f",
  null
  
)

export default component.exports